export const INSERT_ITEM = 'INSERT_ITEM'
export const DELETE_ITEM = 'DELETE_ITEM'

export const ORDERS_LOAD = 'LOAD_ORDERS'
export const ORDER_SET = 'SET_ORDER'
export const ORDERS_SET = 'SET_ORDERS'
export const ORDER_GET = 'GET_ORDER'

export const USER_LIST_SET = 'USER_LIST_SET'

export const USER_ROLE_LIST_SET = 'USER_ROLE_LIST_SET'

export const REGISTRAR_LIST_SET = 'REGISTRAR_LIST_SET'

export const HOSTS_SET = 'SET_HOSTS'

export const PBNS_SET = 'SET_PBNS'
export const PBN_SET = 'SET_PBN'

export const APPLIED_FILTER_SET = 'SET_FILTER'

export const FILTERS_SET = 'SET_FILTERS'
export const FILTERS_UPDATE = 'UPDATE_FILTERS'
export const LANGS_SET = 'SET_LANGS'

export const REPORT_SET = 'SET_REPORT'

export const LINK_ORDERS_SET = 'SET_LINK_ORDERS'
export const LINK_ORDER_SET = 'SET_LINK_ORDER'

export const BUILD_REPORT_SET = 'SET_BUILD_REPORT'
export const BUILD_REPORT_GET = 'GET_BUILD_REPORT'

export const VIEW_FILTERS_SET = 'SET_VIEW_FILTERS'

export const MAINTENANCE_ORDER_GET = 'GET_MAINTENANCE_ORDER'
export const MAINTENANCE_ORDER_SET = 'SET_MAINTENANCE_ORDER'
export const MAINTENANCE_ORDERS_GET = 'GET_MAINTENANCE_ORDERS'
export const MAINTENANCE_ORDERS_SET = 'SET_MAINTENANCE_ORDERS'

export const TASK_SET = 'SET_TASK'
export const TASKS_SET = 'SET_TASKS'
export const TASK_GET = 'GET_TASK'
export const TASKS_GET = 'GET_TASKS'

export const TEMPLATE_GET = 'GET_TEMPLATE'
export const TEMPLATE_SET = 'SET_TEMPLATE'
export const TEMPLATES_GET = 'GET_TEMPLATES'
export const TEMPLATES_SET = 'SET_TEMPLATES'

export const PPC_DATA_SET = 'SET_PPC_DATA'

export const BOOKMARKS_GET = 'GET_BOOKMARKS'
export const BOOKMARKS_SET = 'SET_BOOKMARKS'

export const DATA_SET = 'SET_DATA'

export const PROJECT_TASKS_SET = 'SET_PROJECT_TASKS'

export const PROJECTS_SET = 'SET_PROJECTS'

export const AFFILIATE_COMPANIES_SET = 'SET_AFFILIATE_COMPANIES'
export const AFFILIATE_COMPANY_SET = 'SET_AFFILIATE_COMPANY'

export const BRANDS_SET = 'SET_BRANDS'
export const BRAND_SET = 'SET_BRAND'

export const TOPLISTS_SET = 'SET_TOPLISTS'
export const TOPLIST_SET = 'SET_TOPLIST'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js